import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useRef } from "react";
import { BottomSheetBackdrop, BottomSheetSheet } from "sprout-ui-dom/dist/BottomSheet";
import { Flex } from "sprout-ui-primitives";
import { Button, Editor as BaseEditor, useEditorRef } from "sprout-ui-dom";
import styled from "styled-components";
import { Form } from "sprout-ui-dom/dist/Form";
import { restoreFromLocalStorage, saveToLocalStorage } from "./utils";
const Editor = styled(BaseEditor)`
  .ProseMirror {
    font-size: 20px;
    padding: 24px 16px;
  }
`;
const PostPageCommentEditorMobile = (props)=>{
    const { comment , closeEditor , cacheKey , onUpdateOrCreate , itemId  } = props;
    const { text =""  } = comment || {};
    const handleSave = useCallback((helpers)=>{
        const { text: textToSave  } = helpers.getStateAsText(true);
        onUpdateOrCreate(textToSave);
        return true;
    }, [
        onUpdateOrCreate
    ]);
    const handleChange = useCallback(({ getStateAsText  })=>{
        if (localStorage) {
            const { text: nextText  } = getStateAsText(true);
            if (!nextText) {
                localStorage.removeItem(cacheKey);
                saveToLocalStorage.cancel();
            } else saveToLocalStorage(nextText, cacheKey);
        }
    }, [
        cacheKey
    ]);
    const initialState = useRef(restoreFromLocalStorage(text, cacheKey));
    const editorRef = useEditorRef();
    const updateOrCreate = useCallback(()=>{
        if (editorRef.current) onUpdateOrCreate(editorRef.current.getStateAsText(true).text);
    }, [
        editorRef,
        onUpdateOrCreate
    ]);
    const handleEscape = useCallback(({ blur  })=>{
        blur();
        return true;
    }, []);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(BottomSheetBackdrop, {
                onClick: closeEditor
            }),
            /*#__PURE__*/ _jsxs(BottomSheetSheet, {
                as: Form,
                onSubmit: updateOrCreate,
                children: [
                    /*#__PURE__*/ _jsx(Editor, {
                        itemId: itemId,
                        initialState: initialState.current,
                        autoFocus: "end",
                        mode: "SIMPLE",
                        placeholder: "Add a comment...",
                        onEscape: handleEscape,
                        onSave: handleSave,
                        onChange: handleChange,
                        ref: editorRef,
                        ensureWithinViewport: false
                    }),
                    /*#__PURE__*/ _jsx(Flex, {
                        justifyContent: "flex-end",
                        pb: 3,
                        px: 3,
                        children: /*#__PURE__*/ _jsx(Button, {
                            variant: "bright-blue",
                            type: "submit",
                            children: text ? "Save changes" : "Save"
                        })
                    })
                ]
            })
        ]
    });
};
export default PostPageCommentEditorMobile;
